import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

interface IPromoDescriptionProps {
  description: string;
}

export function PromoDescription({ description }: IPromoDescriptionProps) {
  return (
    <div>
      <ArticleParagraph1 color="black_100">{description}</ArticleParagraph1>
    </div>
  );
}
